
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 6H16.5858L12.2929 10.2929L13.7071 11.7071L18 7.41421V10H20V4H14V6ZM12 6H4V20H18V12H16V18H6V8H12V6Z" fill="currentColor"></path></svg>';export default svg;
    